module.exports = __webpack_public_path__ + "img/CPV_sistema_positivo_sem_grafismo.d16560f8.png";